import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import RequirePermission from '../settings/RequirePermission';

// Lazy so the child-route forms/views (and their heavy deps — the field selector,
// field inputs, applications API) stay out of the app entry chunk. Route files are
// eagerly globbed in routesConfig, so a static import here lands in every page load.
const ApplicationsApp = lazyRetry(() => import('./ApplicationsStudio'));
const ApplicationsCatalog = lazyRetry(() => import('./ApplicationsCatalog'));
const ApplicationEditor = lazyRetry(() => import('./ApplicationEditor'));
const ModuleTemplateEditor = lazyRetry(() => import('./ModuleTemplateEditor'));
const ConnectionsPage = lazyRetry(() => import('./connections/ConnectionsPage'));

/**
 * The ApplicationsApp Route - requires SuperAdmin OR "Create/Edit Applications" permission
 */
const ApplicationsAppRoute: FuseRouteItemType = {
  path: 'admin/applications',
  element: (
    <RequirePermission permission="hasCreateApplications">
      <ApplicationsApp />
    </RequirePermission>
  ),
  children: [
    { index: true, element: <ApplicationsCatalog /> },
    { path: 'modules', element: <ApplicationsCatalog modules /> },
    { path: 'modules/new', element: <ModuleTemplateEditor /> },
    { path: 'modules/:templateId', element: <ModuleTemplateEditor /> },
    { path: 'connections', element: <ConnectionsPage /> },
    {
      path: 'new',
      element: <ApplicationEditor isNew />
    },
    {
      path: ':applicationId',
      element: <ApplicationEditor />
    },
    {
      path: ':applicationId/edit',
      element: <ApplicationEditor />
    }
  ]
};

export default ApplicationsAppRoute;
